module.exports = __webpack_public_path__ + "ni.87480e3d.svg";